import { action } from 'typesafe-actions';
export const CONNECT_WALLET_REQUEST = '[Request] Connect Wallet';
export const CONNECT_WALLET_SUCCESS = '[Success] Connect Wallet';
export const CONNECT_WALLET_FAILURE = '[Failure] Connect Wallet';
export const connectWalletRequest = () => action(CONNECT_WALLET_REQUEST);
export const connectWalletSuccess = (wallet) => action(CONNECT_WALLET_SUCCESS, { wallet });
export const connectWalletFailure = (error) => action(CONNECT_WALLET_FAILURE, { error });
export const ENABLE_WALLET_REQUEST = '[Request] Enable Wallet';
export const ENABLE_WALLET_SUCCESS = '[Success] Enable Wallet';
export const ENABLE_WALLET_FAILURE = '[Failure] Enable Wallet';
export const enableWalletRequest = (providerType) => action(ENABLE_WALLET_REQUEST, { providerType });
export const enableWalletSuccess = (providerType) => action(ENABLE_WALLET_SUCCESS, { providerType });
export const enableWalletFailure = (error) => action(ENABLE_WALLET_FAILURE, { error });
export const CHANGE_ACCOUNT = 'Change Account';
export const changeAccount = (wallet) => action(CHANGE_ACCOUNT, { wallet });
export const CHANGE_NETWORK = 'Change Network';
export const changeNetwork = (wallet) => action(CHANGE_NETWORK, { wallet });
export const DISCONNECT_WALLET_REQUEST = '[Request] Disconnect Wallet';
export const DISCONNECT_WALLET_SUCCESS = '[Success] Disconnect Wallet';
export const DISCONNECT_WALLET_FAILURE = '[Failure] Disconnect Wallet';
export const disconnectWalletRequest = () => action(DISCONNECT_WALLET_REQUEST);
export const disconnectWalletSuccess = () => action(DISCONNECT_WALLET_SUCCESS);
export const disconnectWalletFailure = (error) => action(DISCONNECT_WALLET_FAILURE, { error });
export const FETCH_WALLET_REQUEST = '[Request] Fetch Wallet';
export const FETCH_WALLET_SUCCESS = '[Success] Fetch Wallet';
export const FETCH_WALLET_FAILURE = '[Failure] Fetch Wallet';
export const fetchWalletRequest = () => action(FETCH_WALLET_REQUEST);
export const fetchWalletSuccess = (wallet) => action(FETCH_WALLET_SUCCESS, { wallet });
export const fetchWalletFailure = (error) => action(FETCH_WALLET_FAILURE, { error });
export const SWITCH_NETWORK_REQUEST = '[Request] Switch Network';
export const SWITCH_NETWORK_SUCCESS = '[Success] Switch Network';
export const SWITCH_NETWORK_FAILURE = '[Failure] Switch Network';
export const switchNetworkRequest = (chainId, fromChainId) => action(SWITCH_NETWORK_REQUEST, { chainId, fromChainId });
export const switchNetworkSuccess = (chainId) => action(SWITCH_NETWORK_SUCCESS, { chainId });
export const switchNetworkFailure = (chainId, error) => action(SWITCH_NETWORK_FAILURE, { chainId, error });
export const SET_APP_CHAIN_ID = 'Set App ChainId';
export const setAppChainId = (chainId) => action(SET_APP_CHAIN_ID, { chainId });
//# sourceMappingURL=actions.js.map